// extracted by mini-css-extract-plugin
export default {"emptyResults":"NewSearchingTalents_emptyResults__jIWdp","paginationContainer":"NewSearchingTalents_paginationContainer__kmEtK"};